if (global.Promise == null) {
  global.Promise = require('zousan');
}

if (Object.assign == null) {
  Object.defineProperty(Object, 'assign', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: require('object-assign')
  });
}

module.exports = require('./xhr-promise');



//////////////////
// WEBPACK FOOTER
// ./~/xhr-promise/lib/index.js
// module id = 40
// module chunks = 0 1